import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { FriendListResponse } from 'src/app/interfaces/friend'
import { GenericResponse } from 'src/app/interfaces/main'
import { CustomHttpClient } from 'src/app/services/http/http.service'
import { environment } from 'src/environments/environment'
import { KakaoService } from './../kakao/kakao.service'

@Injectable({
  providedIn: 'root',
})
export class FriendService {
  constructor(private http: CustomHttpClient, private kakaoService: KakaoService) {}

  postKakaoFriendList(): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(`${environment.apiUrl}/v1/profile/kakao/friends/web`, {
      loggingText: 'save kakao friends(only for web)',
    })
  }

  getFriendsList(): Observable<FriendListResponse> {
    return this.http.get<FriendListResponse>(`${environment.apiUrl}/v1/profile/friends`)
  }

  /**
   * 카카오 동의 성공시 true
   * 웹에서는 redirection이 발생하기 때문에, 무조건 false
   *  -> 다시 돌아왔을 때 어짜피 새로 isKakaoFriendAgreed를 불러오기 때문에 그 전까지는 무조건 false.
   */
  async agreeKakaoFriend(url: string): Promise<boolean> {
    this.kakaoService.agreeKakaoFriends(url)
    return false
  }
}
